import React, { useEffect } from 'react';
import Logo from '../../components/svgs/logo';
import { areEqual } from '../../util';
import UserDetailsForm from './user-details';
import CraneImage from '../../assets/images/crane.jpg';
import BtBackground from '../bt-background/bt-background';
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import BtCenter from '../bt-center/bt-center';
import { useTranslation } from 'react-i18next';

const Signup = ({ isProfile, location, history }) => {
  const [userData, setUserData] = React.useState(null);
  const [t] = useTranslation('signup');

  useEffect(() => {
    if (location?.state?.userData) {
      location.state.userData.password = '';
      setUserData(location.state.userData);
      history.replace(location.pathname, null);
    } else {
      history.push('/error');
    }
  }, []);

  return (
    <div className="page-login">
      <BtGrid>
        <BtRow>
          <BtColumn className="bt-w50 first-column bg-white" style={{ padding: '70px 0' }}>
            <BtCenter>
              <div className="align-center bt-w60">
                <div className="m-t-30 m-b-40 d-flex justify-content-center">
                  <Logo size="350px" type="logoWithTitle" />
                </div>
                <h3>{t('pageTitle', 'Välkommen')}</h3>
                <p>
                  {t(
                    'intro',
                    '{{organizationName}} använder Accurator, byggbranschens smarta inköpsverktyg, för att hålla reda på leverantörer, upphandlingar, kommunikation, avtal och erfarenheter. Fyll i uppgifterna nedan för att komma igång.',
                    { organizationName: userData?.organizationName }
                  )}
                </p>
                <UserDetailsForm isProfile={isProfile} user={userData} location={location} history={history} />
              </div>
            </BtCenter>
          </BtColumn>
          <BtColumn className="second-column">
            <BtBackground src={CraneImage} className="bg-login bt-background-position-left" />
          </BtColumn>
        </BtRow>
      </BtGrid>
    </div>
  );
};

export default React.memo(Signup, areEqual);
